import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './en.json'
import de from './de.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, de: { translation: de } },
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tg_lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  })

export default i18n

// The Profile section (and the login flow) write the chosen language to
// localStorage and fire this event so the UI re-renders immediately — no reload.
window.addEventListener('tg_lang_change', () => {
  const lang = localStorage.getItem('tg_lang') || 'en'
  if (i18n.language !== lang) i18n.changeLanguage(lang)
})
